import type { ComputedContentSource, ComputedContentSourceIntegration } from './__generated__';

interface ComputedContentSourceIntegrationTypeParsed {
    category: 'integration';
    integration: string;
    contentSourceId: string;
}

/**
 * Check if a source type is a valid integration source type.
 */
export function checkIsComputedIntegrationSourceType(
    sourceType: ComputedContentSource['type']
): sourceType is ComputedContentSourceIntegration['type'] {
    return sourceType.startsWith('integration:');
}

/**
 * Parse a computed source type string into a parsed source type.
 */
export function parseComputedIntegrationSourceType(
    sourceType: ComputedContentSourceIntegration['type']
): ComputedContentSourceIntegrationTypeParsed {
    const parts = sourceType.split(':');
    if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) {
        throw new Error(`Invalid integration source type: ${sourceType}`);
    }
    return {
        category: 'integration',
        integration: parts[1],
        contentSourceId: parts[2],
    };
}

/**
 * Format a parsed source type into a computed source type string.
 */
export function formatComputedIntegrationSourceType(
    parsed: ComputedContentSourceIntegrationTypeParsed
): ComputedContentSourceIntegration['type'] {
    return `${parsed.category}:${parsed.integration}:${parsed.contentSourceId}`;
}
